const API_BASE_URL = import.meta.env.VITE_API_URL;

export const seoService = {
  async getActiveSeo(pageKey: string): Promise<any> {
    const response = await fetch(`${API_BASE_URL}/seo/public.php?page=${pageKey}`);
    const data = await response.json();
    if (!data.success) return null;
    return data.data;
  }
};
